var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDownSky(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 10,
    height: 6
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "icon-down-sky_svg__a",
    width: "103.3%",
    height: "102.7%",
    x: "-1.7%",
    y: "-1%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "icon-down-sky_svg__c",
    width: "102%",
    height: "103.2%",
    x: "-1%",
    y: "-1.1%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "icon-down-sky_svg__f",
    width: "100.9%",
    height: "111.8%",
    x: "-.4%",
    y: "-5.9%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceAlpha",
    result: "shadowBlurInner1",
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic",
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowInnerInner1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.197124094 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "icon-down-sky_svg__g",
    width: "101.7%",
    height: "123.5%",
    x: "-.9%",
    y: "-11.8%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceAlpha",
    result: "shadowBlurInner1",
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic",
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowInnerInner1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.197124094 0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "icon-down-sky_svg__e",
    width: 460,
    height: 34,
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "icon-down-sky_svg__h",
    width: 460,
    height: 34,
    rx: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "icon-down-sky_svg__b",
    d: "M742 30h206a2 2 0 012 2v256a2 2 0 01-2 2H742a2 2 0 01-2-2V32a2 2 0 012-2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icon-down-sky_svg__d",
    d: "M6 0h688a6 6 0 016 6v427a6 6 0 01-6 6H6a6 6 0 01-6-6V6a6 6 0 016-6z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-1258-521H662V679h-1920z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-788 -279)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#icon-down-sky_svg__a)",
    xlinkHref: "#icon-down-sky_svg__b"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#047DE0",
    strokeLinejoin: "square",
    d: "M742 30.5a1.5 1.5 0 00-1.5 1.5v256a1.5 1.5 0 001.5 1.5h206a1.5 1.5 0 001.5-1.5V32a1.5 1.5 0 00-1.5-1.5H742z"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#DCE2E7",
    d: "M-898-349.995c0-1.107.897-2.005 2.007-2.005H299.993c1.108 0 2.007.895 2.007 2.005v1935.99a2.005 2.005 0 01-2.007 2.005H-895.993a2.004 2.004 0 01-2.007-2.005v-1935.99z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M-1258-521H662V679h-1920z",
    opacity: 0.603
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-648 -140)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#icon-down-sky_svg__c)",
    xlinkHref: "#icon-down-sky_svg__d"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#F3F6FA",
    xlinkHref: "#icon-down-sky_svg__d"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-648-100H52v393a6 6 0 01-6 6h-688a6 6 0 01-6-6v-393z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-438 -14)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#icon-down-sky_svg__e"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#icon-down-sky_svg__f)",
    xlinkHref: "#icon-down-sky_svg__e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 459,
    height: 33,
    x: 0.5,
    y: 0.5,
    stroke: "#D4D4D4",
    strokeLinejoin: "square",
    rx: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-438 -14)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#icon-down-sky_svg__g)",
    xlinkHref: "#icon-down-sky_svg__h"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 462,
    height: 36,
    x: -1,
    y: -1,
    stroke: "#B5D3FF",
    strokeWidth: 2,
    rx: 6
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#D3D3D3",
    d: "M-11.5-13.5v33H16a5.5 5.5 0 005.5-5.5V-8a5.5 5.5 0 00-5.5-5.5h-27.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 6l5-6H0z",
    fill: "#B5D3FF"
  }))));
}
export default __webpack_public_path__ + "af14bd502a36c2ce0f263c2aa5b0c791.svg";
export { SvgIconDownSky as ReactComponent };